import { USER_OFFLINE_ERROR, USER_OFFLINE_SUCCESS } from "./actionTypes";
import { retrieveUserCredentials } from "../actions/vtrIndexedDB";
import { toast } from "react-toastify";

export const userOffline = ({ username, password }) => (dispatch) => {
  retrieveUserCredentials(username, password)
    .then((data) => {
      if (Object.keys(data).length > 0) {
        dispatch({
          type: USER_OFFLINE_SUCCESS,
          payload: {
            ...data.userPayload,
          },
          validationsPayload: { ...data.validationsData },
        });
      } else {
        toast.error("No valid user credentials received.", { autoClose: false });
        dispatch({
          type: USER_OFFLINE_ERROR,
          payload: "No valid user credentials received.",
        });
      }
    })
    .catch((error) => {
      console.log("An error occurred: ", error);
      toast.error(`An error occurred: ${error}`, { autoClose: false });
      dispatch({ type: USER_OFFLINE_ERROR, error: error });
    });
};
